module.exports = __webpack_public_path__ + "img/Group 1042two.8c615f59.png";